import './header.scss';

import KeyboardBackspaceRoundedIcon from '@mui/icons-material/KeyboardBackspaceRounded';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import LinearProgress from '@mui/material/LinearProgress';
import isNil from 'lodash/isNil';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import defaultLogo from '../../assets/logo-default.svg';
import useLeadChannelStore from '../../store/leadChannelStore/useLeadChannelStore';
import useNavigationPaneStore from '../../store/navigationPaneStore/useNavigationPaneStore';
import { locator } from '../../testing/e2e-locator/locator';
import { HeaderProps } from './types/HeaderProps';

export const Header = ({
  showDrawerToggleOnMobileOnly = false,
  onBackClick,
  progress,
  showDefaultLogo = false,
  showDrawerToggle = false,
  showLogo = false,
  trailing,
}: HeaderProps): ReactNode => {
  const {
    computed: { primaryLogoURL },
  } = useLeadChannelStore();

  const { setDrawerOpen } = useNavigationPaneStore();

  const { t } = useTranslation();

  const className = [
    'header',
    showDrawerToggleOnMobileOnly && 'header-drawer-toggle-mobile-only',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <header className={className} data-testid={locator.components.header.root}>
      {onBackClick && (
        <button
          aria-label="Go back"
          data-testid={locator.components.header.backButton}
          type="button"
          onClick={onBackClick}
        >
          <KeyboardBackspaceRoundedIcon />
        </button>
      )}

      {showLogo && (
        <img
          alt={t('imageAlts.logo')}
          data-testid={locator.components.header.logoImage}
          src={showDefaultLogo ? defaultLogo : primaryLogoURL || defaultLogo}
        />
      )}

      {showDrawerToggle && (
        <button
          aria-label="Toggle drawer"
          className="header-drawer-toggle"
          data-testid={locator.components.header.drawerButton}
          type="button"
          onClick={(): void => {
            setDrawerOpen(true);
          }}
        >
          <MenuRoundedIcon />
        </button>
      )}

      {trailing}

      <div className="header-band">
        {!isNil(progress) && (
          <LinearProgress
            aria-label="Percent complete"
            data-testid={locator.components.header.progress}
            value={progress}
            variant="determinate"
          />
        )}
      </div>
    </header>
  );
};
